import { createSlice } from '@reduxjs/toolkit';
import { getBatchDefinition } from 'ducks/batch-definition/operators';
import { Slices } from 'ducks/slices';
import { BatchDefinition as BatchDefinitionType } from 'ducks/types/store-types';
import { NullableNumberInterface } from 'ducks/types/type-helpers';
import { normalizeBatchDefinition } from 'ducks/utils';

export type BatchDefinitionState = NullableNumberInterface<BatchDefinitionType>;

const initialState: BatchDefinitionState = {
  batch_definition_id: null,
  batch_definition_name: '',
  project_id: null,
  project_name: '',
  organization_id: null,
  organization_name: '',
  description: '',
  created_by: '',
  created_datetime_utc: '',
  is_archived: false,
  timeout_seconds_masked: '',
  sort_datetime_utc: '',
  created_datetime_utc_formatted: '',
  sort_datetime: '',
  created_datetime_formatted: '',
  uuid: '',
};

const batchDefinitionSlice = createSlice({
  name: Slices.BATCH_DEFINITION,
  initialState,
  reducers: {
    clearBatchDefinition: () => {
      return initialState;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getBatchDefinition.pending, () => {
        return initialState;
      })
      .addCase(getBatchDefinition.fulfilled, (_, { payload }) => {
        return normalizeBatchDefinition(payload);
      })
      .addCase(getBatchDefinition.rejected, () => {
        return initialState;
      });
  },
});

export const { clearBatchDefinition } = batchDefinitionSlice.actions;

export default batchDefinitionSlice.reducer;
